import SVG from '@/assets/svg/SVG';
import { MdOutlineJoinInner, MdTransform, TbTablePlus } from '@/components/react-icons/main';
import { isValidElement, memo, useMemo } from 'react';

const dynamicIcons = { TbTablePlus, MdOutlineJoinInner, MdTransform };

const getIconType = (icon) => {
  if (isValidElement(icon)) {
    return 'component';
  }
  if (typeof icon === 'string') {
    return 'string';
  }
  return 'function';
};

const getIconTitle = (icon) => {
  const title = icon?.type ? icon?.type?.toString() : icon?.toString();
  return title?.split('(')?.[0]?.replace('function ', '') || '';
};

const IconV2 = memo(({ id, children, className = '', variant = '', title, titleDelay, shortcut, onClick, onMouseUp, size, icon, style = {}, ...props }) => {
  let Icon = icon;
  const type = useMemo(() => getIconType(Icon), [Icon]);
  const iconTitle = useMemo(() => getIconTitle(icon), [icon]);

  if (type === 'component') {
    // console.warn('Warning: Icon was passed as a JSX element (<Something />) instead of a component reference (Something). This may cause unnecessary re-renders. This is the icon:', icon);
  }

  if (type === 'string') {
    Icon = dynamicIcons[Icon] || Icon;
  }

  const combinedClassName = useMemo(() => {
    return `comp-icon-v2 ${variant || ''} ${onClick ? 'clickable' : ''} ${size ? `size-${size}` : ''} ${className || ''}`.trim();
  }, [variant, onClick, size, className]);

  return (
    <div id={id} className={combinedClassName} style={style} data-title={title} data-title-delay={titleDelay} data-title-shortcut={shortcut} onClick={onClick} onMouseUp={onMouseUp} data-icon-title={iconTitle} {...props}>
      {icon && (
        <>
          {type === 'function' && <Icon />}
          {type === 'component' && Icon}
          {type === 'string' && <SVG icon={Icon} />}
        </>
      )}
      {!icon && <>{children}</>}
    </div>
  );
});

IconV2.displayName = 'IconV2';

export default IconV2;
